"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-thirteen/sections/blogSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type BlogSection466sItem = {
    key: Key | null | undefined;
    /** Detected variants: "1s" | "2s" | "3s" */
    dataWowDuration: string;
    /** Detected variants: "/Templates/Doccure/img/blog/blogs-img-one.jpg" | "/Templates/Doccure/img/blog/blogs-img-two.jpg" | "/Templates/Doccure/img/blog/blogs-img-three.jpg" */
    src: string;
    /** Detected variants: "Top 10 Daily Vitamins You Shouldn’t Skip in 2025" | "A Beginner’s Guide to Over the Counter Medicines" | "How to Choose the Right Online Pharmacy Safely" */
    link0Text: ReactNode;
    /** Detected variants: "Health Insights" | "Medicine" | "E-Pharmacy" */
    span0Text: ReactNode;
    /** Detected variants: "14 Jan 2026" | "02 Feb 2026" | "18 Jan 2026" */
    span2Text: ReactNode;
    /** Detected variants: "col-lg-4 col-md-6 col-sm-6" */
    className?: string;
    /** Detected variants: "blog-item-thirteen wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "blog-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "blogs" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "blog-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "all_routes.blogDetails" */
    href?: string;
    /** Detected variants: "text" */
    p0ClassName?: string;
    /** Detected variants: "|" */
    span1Text?: ReactNode;
    /** Detected variants: "divide" */
    span1ClassName?: string;
};
export type HomeThirteenBlogSectionGeneratedProps = {
    divDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection466sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    divDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection466sItem) => Partial<ComponentProps<"h3">>);
    divDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection466sItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDiv0Div0DivDataWowDuration?: string;
    /** Default: "Our Updated Articles and Tips" */
    sectionDiv0Div0H20H2Text?: ReactNode;
    sectionDiv0Div0H20H2Visible?: boolean;
    sectionDiv0Div0H20H2Renderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0H20H2Props?: Partial<ComponentProps<"h2">>;
    /** Default: "all_routes.blogDetails" */
    sectionDiv0Div0Link0LinkHref?: string;
    /** Default: "View All" */
    sectionDiv0Div0Link0LinkText?: ReactNode;
    sectionDiv0Div0Link0LinkVisible?: boolean;
    sectionDiv0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    sectionDiv0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    sectionDiv0Div1ClassName?: string;
    blogSection466s: BlogSection466sItem[];
    blogSection466sItemWrapper?: (item: BlogSection466sItem, content: ReactNode) => ReactNode;
    blogSection466sRenderer?: (defaultNode: ReactNode) => ReactNode;
    blogSection466sLinkVisible?: boolean;
    blogSection466sLinkRenderer?: (item: BlogSection466sItem, defaultNode: ReactNode) => ReactNode;
    blogSection466sImageVisible?: boolean;
    blogSection466sImageRenderer?: (item: BlogSection466sItem, defaultNode: ReactNode) => ReactNode;
    blogSection466sH3Visible?: boolean;
    blogSection466sH3Renderer?: (item: BlogSection466sItem, defaultNode: ReactNode) => ReactNode;
    blogSection466sLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: BlogSection466sItem) => Partial<ComponentProps<typeof SmartLink>>);
    blogSection466sImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BlogSection466sItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    blogSection466sH3Props?: Partial<ComponentProps<"h3">> | ((item: BlogSection466sItem) => Partial<ComponentProps<"h3">>);
};

const HomeThirteenBlogSectionGenerated: FC<HomeThirteenBlogSectionGeneratedProps> = ({
    sectionDiv0Div0DivDataWowDuration = "1s",
    sectionDiv0Div0H20H2Text = "Our Updated Articles and Tips",
    sectionDiv0Div0H20H2Visible,
    sectionDiv0Div0H20H2Renderer,
    sectionDiv0Div0H20H2Props,
    sectionDiv0Div0Link0LinkHref = "all_routes.blogDetails",
    sectionDiv0Div0Link0LinkText = "View All",
    sectionDiv0Div0Link0LinkVisible,
    sectionDiv0Div0Link0LinkRenderer,
    sectionDiv0Div0Link0LinkProps,
    divDiv0Div0ImageWithBasePath0ImageProps,
    divDiv0Div1H30H3Props,
    divDiv0Div1H30Link0LinkProps,
    sectionDiv0Div1ClassName,
    blogSection466s,
    blogSection466sItemWrapper,
    blogSection466sRenderer,
    blogSection466sLinkVisible,
    blogSection466sLinkRenderer,
    blogSection466sImageVisible,
    blogSection466sImageRenderer,
    blogSection466sH3Visible,
    blogSection466sH3Renderer,
    blogSection466sLinkProps,
    blogSection466sImageProps,
    blogSection466sH3Props,
}) => {
    return (
        <section className="blog-section-thirteen section pt-0">
            <div className="container">
                <div className="section-header section-header-thirteen wow fadeInUp" data-wow-duration={sectionDiv0Div0DivDataWowDuration}>
                    {renderNode(sectionDiv0Div0H20H2Visible, sectionDiv0Div0H20H2Renderer, (
                        <h2 className="section-title" {...(sectionDiv0Div0H20H2Props ?? {})}>{sectionDiv0Div0H20H2Text}</h2>
                    ))}
                    {renderNode(sectionDiv0Div0Link0LinkVisible, sectionDiv0Div0Link0LinkRenderer, (
                        <SmartLink href={sectionDiv0Div0Link0LinkHref} className="btn theme-12-btn" {...(sectionDiv0Div0Link0LinkProps ?? {})}>
                            {sectionDiv0Div0Link0LinkText}
                            <i className="isax isax-arrow-right-1 ms-2" />
                            {" "}
                        </SmartLink>
                    ))}
                </div>
                <div className={sectionDiv0Div1ClassName ?? "row g-4"}>
                    {renderCollectionNode(
                        blogSection466s,
                        (item: BlogSection466sItem) => (
                            <div className={item.className ?? "col-lg-4 col-md-6 col-sm-6"} key={item.key}>
                                <div className={item.div0ClassName ?? "blog-item-thirteen wow fadeInUp"} data-wow-duration={item.dataWowDuration}>
                                    <div className={item.div0ClassName2 ?? "blog-overlay"}>
                                        {renderItemNode(blogSection466sImageVisible, blogSection466sImageRenderer, item, (
                                            <SmartImage src={item.src} alt={item.alt ?? "blogs"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof blogSection466sImageProps === "function" ? blogSection466sImageProps(item) : (blogSection466sImageProps ?? {}))} {...(typeof divDiv0Div0ImageWithBasePath0ImageProps === "function" ? divDiv0Div0ImageWithBasePath0ImageProps(item) : (divDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                    </div>
                                    <div className={item.div1ClassName ?? "blog-content"}>
                                        <p className={item.p0ClassName ?? "text"}>
                                            <span>{item.span0Text}</span>
                                            <span className={item.span1ClassName ?? "divide"}>{item.span1Text ?? "|"}</span>
                                            <span>{item.span2Text}</span>
                                        </p>
                                        {renderItemNode(blogSection466sH3Visible, blogSection466sH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof blogSection466sH3Props === "function" ? blogSection466sH3Props(item) : (blogSection466sH3Props ?? {}))} {...(typeof divDiv0Div1H30H3Props === "function" ? divDiv0Div1H30H3Props(item) : (divDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(blogSection466sLinkVisible, blogSection466sLinkRenderer, item, (
                                                    <SmartLink href={item.href ?? "all_routes.blogDetails"} {...(typeof blogSection466sLinkProps === "function" ? blogSection466sLinkProps(item) : (blogSection466sLinkProps ?? {}))} {...(typeof divDiv0Div1H30Link0LinkProps === "function" ? divDiv0Div1H30Link0LinkProps(item) : (divDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ),
                        blogSection466sItemWrapper,
                        blogSection466sRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeThirteenBlogSectionGenerated;
